import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from "native-base";
export const InsulinQuantityListItem = ({ units, type }) => {
    switch (type) {
        case "other":
            return (_jsxs(Box, Object.assign({ display: "flex", alignItems: "center", flexDirection: "row" }, { children: [_jsx(Box, { bgColor: "gray.400", width: "16px", height: "16px", rounded: "full", mr: 2 }), _jsxs(Text, { children: [units, " E"] })] })));
        case "rapid":
            return (_jsxs(Box, Object.assign({ display: "flex", alignItems: "center", flexDirection: "row" }, { children: [_jsx(Box, { bgColor: "blue.300", width: "16px", height: "16px", rounded: "full", mr: 2 }), _jsxs(Text, { children: [units, " E"] })] })));
        case "basal":
            return (_jsxs(Box, Object.assign({ display: "flex", alignItems: "center", flexDirection: "row" }, { children: [_jsx(Box, { bgColor: "blue.500", width: "16px", height: "16px", rounded: "full", mr: 2 }), _jsxs(Text, { children: [units, " E"] })] })));
        default:
            return _jsx(Box, { children: "-" });
    }
};
export const InsulinQuantityBubbleMobile = ({ type }) => {
    switch (type) {
        case "other":
            return (_jsx(Box, { bgColor: "gray.400", width: "8px", height: "8px", rounded: "full" }));
        case "basal":
            return (_jsx(Box, { bgColor: "blue.300", width: "8px", height: "8px", rounded: "full" }));
        case "rapid":
            return (_jsx(Box, { bgColor: "blue.500", width: "8px", height: "8px", rounded: "full" }));
        default:
            return (_jsx(Box, { bgColor: "gray.400", width: "16px", height: "16px", rounded: "full" }));
    }
};
